import React, { Component } from 'react'
import DataViewer from '../data-viewer/container'
import './style.css'
import './style.mobile.css'

export default class MapViewer extends Component {
    constructor() {
        super();
        this.state = {
            mapData: window.config.map,
            index: 0
        }
    }

    getMainContentView() {
        var currentViewData = this.state.mapData.endpoint?.data[this.state.index] || {};

        var mapView;

        if (currentViewData.type == 'map') {
            mapView = <iframe src={currentViewData.value} scrolling="no" />;
        }

        return <div className="main-viewer">
            <div className="controller">
                {/* <div className="zoom-actions">
                    <FaMinus />
                    <FaPlus />
                </div> */}
                <div className="mode-actions">

                </div>
            </div>
            <div className="map-viewer">
                {mapView}
            </div>
        </div>
    }

    getExtendedView() {
        var extendView = this.state.mapData.endpoint || {};

        return <div className="additional-viewer">
            <div className="title">
                {extendView.title}
            </div>
            <div className="data">
                <DataViewer
                    data={extendView.data}
                    dataType={extendView.type}
                    onItemClick={(val, index) => this.setState({ index })} />
            </div>
        </div>
    }

    render() {
        if (this.props.minimize) {
            return (
                <div className="map-container minimize">
                    {this.getMainContentView.call(this)}
                </div>
            )
        }

        return (
            <div className="map-container">
                {this.getMainContentView.call(this)}
                {this.getExtendedView.call(this)}
            </div>
        )
    }
}
